import * as React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import * as routes from "../constants/routes";
import {firebase} from "../firebase";
import {withAuthentication} from "../firebase/withAuthentication";
import {MenuVertical} from "./Menu";
import {Home} from "../pages/Home";
import {SignIn} from "../pages/SignIn";
import {Navigation} from "./Navigation";
import {CategoriesPage} from "../pages/Categories";
import {CategoryPage} from "../pages/CategoryDetails";
import {TagsPage} from "../pages/Tags";
import {UsersPage} from "../pages/Users";
import {UserDetailsPage} from "../pages/userDetails";
import './styles.css';

class AppComponent extends React.Component {
    constructor(props: any) {
        super(props);

        this.state = {
            authUser: null,
            categories: null,
            gifs: null,
            tags: null,
            users: null,
        };
    }

    public componentDidMount() {
        firebase.auth.onAuthStateChanged(authUser => {
            if (authUser) {
                this.setState(() => ({authUser: authUser}))
            } else {
                this.setState(() => ({authUser: null}));
            }
        });
    }

    public render() {
        const {authUser}: any = this.state;
        return (
            <BrowserRouter>
                <div>
                    {authUser ?
                        <>
                            <Navigation/>
                            <MenuVertical/>
                        </> : null}
                    <div className={authUser ? "contentbox" : ""}>
                        <Switch>
                            <Route exact={true} path={routes.SIGN_IN} component={SignIn}/>
                            <Route exact={true} path={routes.HOME} component={Home}/>
                            <Route exact={true} path={routes.CATEGORIES} component={CategoriesPage}/>
                            <Route exact={true} path={routes.CATEGORY} component={CategoryPage}/>
                            <Route exact={true} path={routes.TAGS} component={TagsPage}/>
                            <Route exact={true} path={routes.USERS} component={UsersPage}/>
                            <Route exact={true} path={routes.USER} component={UserDetailsPage}/>
                        </Switch>
                    </div>
                </div>
            </BrowserRouter>
        );
    }
}

export const App = withAuthentication(AppComponent);



// WEBPACK FOOTER //
// ./src/components/App.tsx